<div class="support-button no-print">
    <a class="support-button__link"
        [href]="supportUrl"
        target="_blank">
        <mat-icon class="support-button__icon material-symbols-sharp_bold"
            fontSet="material-symbols-sharp">help</mat-icon>
        <span class="support-button__label">Support</span>
    </a>
</div>